var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-testid":_vm.getTestId('admin-company-managers-page')}},[_c('CompanyManagerCrudTable',{attrs:{"data-testid":_vm.getTestId('admin-company-managers-table')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }